import React from "react";
import Data from "../content.json";

import { FaHandPointRight } from "react-icons/fa";
import { Helmet } from "react-helmet";

function NonTeachingMembers() {
  return (
    <>
      <Helmet>
        <title>Non-Teaching Staff | University of Education</title>
      </Helmet>
      <div className="MembersContainer">
        <div id="Heading">
          <h1>Non-Teaching Staff</h1>
        </div>

        <div className="Members">
          {Object.entries(Data.nonTeachingMembers).map((nonTeachingData) => {
            return (
              <div className="MemberCard" data-aos="fade-up">
                <div className="TopMemberCard">
                  <img src={nonTeachingData[1].img} alt="memberImg1" />
                  <h2>{nonTeachingData[1].name}</h2>
                  <h4>{nonTeachingData[1].role}</h4>
                </div>
                <div className="MiddleMemberCard">
                  <table>
                    <tbody>
                      {nonTeachingData[1].qualification && (
                        <tr>
                          <td style={{ verticalAlign: "top", paddingRight: "10px", width: "20px" }}>
                            <FaHandPointRight className="tickIcon" />
                          </td>
                          <td style={{ textAlign: "left" }}>
                            <p>{nonTeachingData[1].qualification}</p>
                          </td>
                        </tr>
                      )}
                      {nonTeachingData[1].email && (
                        <tr>
                          <td style={{ verticalAlign: "top", paddingRight: "10px", width: "20px" }}>
                            <FaHandPointRight className="tickIcon" />
                          </td>
                          <td style={{ textAlign: "left", wordBreak: "break-all" }}>
                            <p>{nonTeachingData[1].email}</p>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default NonTeachingMembers;
